module.exports = __webpack_public_path__ + "static/media/calendar-red.68f3468f.svg";